import styled from "styled-components";
export const Dropdown = styled.button `
  background-clip: padding-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 2.5rem;
  width: auto;
  background-color: ${({ theme, $selected }) => $selected
    ? `rgba(${theme.colors.transparentBlack}, 0.16);`
    : `rgba(${theme.colors.transparentBlack}, 0);`};
  border: 1px solid
    ${({ theme, $selected }) => $selected
    ? `rgba(${theme.colors.transparentBlack}, 0.14);`
    : `rgba(${theme.colors.transparentBlack}, 0);`};
  color: ${({ theme, $selected }) => $selected ? theme.colors.black : theme.colors.grey13};
  font-size: ${({ theme }) => theme.fontTokens.font13[0]};
  line-height: ${({ theme }) => theme.fontTokens.font13[1]};
  padding-right: 0.25rem;
  padding-left: 0.25rem;

  svg {
    ${({ theme, $selected }) => $selected ? `fill:  ${theme.colors.grey13}` : ""};
  }

  span {
    padding-left: 0.375rem;
  }

  &:hover {
    border: 1px solid
      ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0.08);`};
    background-color: ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0.08);`};
  }

  &:focus {
    ${({ $focused, theme }) => $focused ? `border: 1px solid ${theme.colors.primaryLight};` : ""};

    ${({ theme, $focused }) => $focused
    ? `outline: 1px solid ${theme.colors.primary};`
    : "outline: none;"};
  }

  &:active {
    border: 1px solid ${({ theme }) => theme.colors.grey15};
    background-color: ${({ theme }) => theme.colors.grey15};
    color: ${({ theme }) => theme.colors.white};

    svg {
      fill: ${({ theme }) => theme.colors.white};
    }
  }

  &:disabled {
    cursor: default;
    border: 1px solid
      ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0);`};
    background-color: ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0);`};
    color: ${({ theme }) => `rgba(${theme.colors.transparentBlack}, 0.3);`};
  }
`;
